import React from 'react';
import { BarChart3, Lock, Zap, Plug, Globe } from 'lucide-react';
export function ControlSlide() {
  const modules = [{
    title: 'Dashboard & Reporting',
    icon: BarChart3,
    points: ['KPI dashboards & analytics', 'Heatmaps and trends', 'Custom reporting & exports'],
    colSpan: 'col-span-2'
  }, {
    title: 'User Management & Security',
    icon: Lock,
    points: ['Roles & permissions (RBAC)', 'Multi-level access control', 'Audit trails & activity logs'],
    colSpan: 'col-span-2'
  }, {
    title: 'Real-Time Engine',
    icon: Zap,
    points: ['Live tracking updates', 'Notifications & alerts', 'Server-Sent Events (SSE)'],
    colSpan: 'col-span-2'
  }, {
    title: 'Ecosystem Integrations',
    icon: Plug,
    points: ['Microsoft Dynamics 365 (ERP, leases, fines)', 'UAE Pass (identity & digital signatures)', 'WhatsApp Business (driver communication)'],
    colSpan: 'col-start-2 col-span-2'
  }, {
    title: 'External Services',
    icon: Globe,
    points: ['Sheel (emergency roadside)', 'DU M2M (device communication)', 'S3 Mulkiya (vehicle document parsing)'],
    colSpan: 'col-start-4 col-span-2'
  }];
  return <div className="flex flex-col w-screen h-screen overflow-hidden bg-white text-[#1a1a2e] px-8 py-6" data-id="element-156">
      {/* Top Header */}
      <div className="flex justify-between items-start shrink-0" data-id="element-157">
        <img src="https://cdn.magicpatterns.com/uploads/wGUVVF9ppu2J6VxJ2kpoN3/Pair2_Logo.png" alt="Pair2 Logo" className="h-8 w-auto object-contain" data-id="element-158" />
      </div>

      {/* Title */}
      <div className="text-center shrink-0 mb-6 mt-2" data-id="element-159">
        <span className="text-xs font-semibold text-[#2EBCB0] uppercase tracking-widest" data-id="element-160">
          Control & Integrations
        </span>
        <h1 className="text-[1.25rem] font-bold text-[#1a1a2e] mt-1" data-id="element-161">
          Platform Control, Intelligence & Integrations
        </h1>
      </div>

      {/* Main Grid - 6 columns to allow centering the bottom 2 items */}
      <div className="flex-grow flex items-center justify-center w-full max-w-7xl mx-auto" data-id="element-162">
        <div className="grid grid-cols-6 gap-5 w-full" data-id="element-163">
          {modules.map((mod, idx) => <div key={idx} className={`bg-gray-50/50 border border-gray-100 rounded-xl p-5 flex flex-col hover:shadow-md transition-shadow duration-300 ${mod.colSpan}`} data-id="element-164">
              <div className="flex items-center gap-3 mb-4" data-id="element-165">
                <div className="w-10 h-10 rounded-lg bg-[#2EBCB0]/10 text-[#2EBCB0] flex items-center justify-center shrink-0" data-id="element-166">
                  <mod.icon className="w-5 h-5" data-id="element-167" />
                </div>
                <h3 className="font-bold text-[0.85rem] text-[#1a1a2e] leading-tight" data-id="element-168">
                  {mod.title}
                </h3>
              </div>
              <ul className="space-y-2.5 mt-auto" data-id="element-169">
                {mod.points.map((point, pIdx) => <li key={pIdx} className="flex items-start gap-2" data-id="element-170">
                    <div className="w-1.5 h-1.5 rounded-full bg-[#2EBCB0] mt-1.5 shrink-0" data-id="element-171" />
                    <span className="text-[0.75rem] text-gray-600 leading-snug" data-id="element-172">
                      {point}
                    </span>
                  </li>)}
              </ul>
            </div>)}
        </div>
      </div>

      {/* Bottom Tagline */}
      <div className="text-center shrink-0 mt-4" data-id="element-173">
        <p className="text-[0.75rem] italic text-gray-400" data-id="element-174">
          "A secure, scalable, and fully integrated national platform."
        </p>
      </div>
    </div>;
}